export const DEFAULT_LOCALE = 'pt-BR' as const;

export const RUNTIME_LOCALES = ['pt-BR', 'en-US'] as const;
export const FUTURE_LOCALES = ['es-ES'] as const;

export type RuntimeLocale = (typeof RUNTIME_LOCALES)[number];
export type FutureLocale = (typeof FUTURE_LOCALES)[number];
export type LocaleCode = RuntimeLocale | FutureLocale;

export type I18nSource = 'company' | 'local' | 'browser' | 'default';

export type TranslationValue = string | TranslationDictionary;
export interface TranslationDictionary {
  [key: string]: TranslationValue;
}

export interface I18nState {
  locale: RuntimeLocale;
  source: I18nSource;
  dictionaries: Partial<Record<RuntimeLocale, TranslationDictionary>>;
  loading: boolean;
}
